import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/manyOrEmpty/list',
      data
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/etf/pair/list'
    });
  }
};
